<ng-container *ngIf="processResult">
  <div
    *ngFor="let section of getActionButtonsSections()"
  >
    <span
      *ngIf="section.section"
      class="d-block text-normal text-complementary-color-a pb-2"
    >
      {{section.section}}:
    </span>
    <div
      class="w-100 d-flex justify-content-center align-items-center mb-2 rounded-2 "
      *ngFor="let button of section.buttons; let index=index"
      [ngClass]="{
            'hover:text-white': !loadingActionButton.status,
            'hover:bg-primary-color': !loadingActionButton.status,
            'pointer': !loadingActionButton.status
          }"

      [ngStyle]="{
          backgroundColor: button.color,
          padding: '2px 4px',
          color: button.text_color
          }"
      (click)="dispatchActionButton(button.id)"
    >
      <div
        *ngIf="loadingActionButton.status && loadingActionButton.button == button.id"
        class="spinner-grow spinner-grow-sm me-1" role="status"
      ></div>
      <span
        *ngIf="button.icon && loadingActionButton.button != button.id"
        class="material-symbols-outlined text-sub-title me-1"
      >
            {{button.icon}}
          </span>
      <span
        class="text-normal user-select-none"
      >
            {{button.label}}
          </span>
    </div>
  </div>


</ng-container>

